/**
 * Shared verbose-logging helper for the Documents upload paths
 * (SharePoint + Google Drive).
 *
 * Logs are gated behind `VITE_DEBUG_UPLOADS=true` so they stay out of
 * production consoles but can be turned on in `.env.local` when
 * diagnosing a slow or silently-failing upload. Matches the pattern used
 * by `VITE_DEBUG_GRAPH` for the Microsoft Graph client.
 */

export const isUploadDebugEnabled = (): boolean =>
  import.meta.env.VITE_DEBUG_UPLOADS === 'true';

type UploadDebugSource = 'sharepoint' | 'google' | 'dropzone';

export const logUploadDebug = (
  source: UploadDebugSource,
  message: string,
  data?: unknown,
): void => {
  if (!isUploadDebugEnabled()) return;
  const prefix = `[UPLOAD:${source}]`;
  if (data === undefined) {
    console.log(`${prefix} ${message}`);
  } else {
    console.log(`${prefix} ${message}`, data);
  }
};
